import {WechatInitOptions} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {TokenService} from "../../token/tokenservice";
import {MailTokenService} from "../../token/mailtokenservice";

/**
 * 企业微信 部门
 */
export class DepartmentService {

  /*
   * 读取部门列表
   * */
  static async getDepartmentList(departmentId: number = null): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new MailTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "GET",
      uri: `${wechatOptions.corp.apiUrl}department/list`,
      qs: {
        access_token: accessToken
      },
      json: true
    };
    if (departmentId !== null) {
      param.qs.id = departmentId;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`get department list failed , response:`);
      console.error(result);
    }

    return "";
  }

}
